import * as React from 'react';
import { getBasePath } from '../../utils/browser';
import IconImage from '../common/IconImage';
import { AppStates } from '../../reducers/app';
import { connect } from 'react-redux';
import { TextboxState } from '../../reducers/ui/textbox';
import { ShapeKind, FontType } from '../../drawing/types';
import { Color } from '../../types/color';
import { getColorFilter } from '../../utils/ui';

interface TextboxIconImageProps {
  readonly buttonNumber: number;
  readonly textbox: TextboxState;
  readonly svgStyle?: React.CSSProperties;
}

const iconPositonStyle: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
};

const TextboxIconImage: React.SFC<TextboxIconImageProps> = React.memo((props) => {
  const { buttonNumber, textbox, svgStyle } = props;
  const { fillColor, lineColor, fontType, textColor, type } = textbox.toolSettings[buttonNumber];

  const baseDir = getBasePath();

  let baseIconName = 'dynamic/textbox/icon_txtbox_balloon_type';
  switch (type) {
    case ShapeKind.Sticky:
      baseIconName += '_01';
      break;
    case ShapeKind.Balloon:
      baseIconName += '_02';
      break;
    case ShapeKind.None:
      break;
  }

  let textIconName = 'dynamic/textbox/icon_txtbox_balloon_type_03';
  switch (fontType) {
    case FontType.Gothic:
      textIconName += '_gothic';
      break;
    case FontType.Mincho:
      textIconName += '_mincho';
      break;
  }
  const textImageColorFilter = getColorFilter(textColor);
  const textImgSrc = `${baseDir}/images/tool-icons/${textIconName}.png`;

  if (type === ShapeKind.None) {
    return (
      <IconImage
        src={textImgSrc}
        svgStyle={{ position: 'absolute', ...svgStyle }}
        { ...textImageColorFilter } />
    );
  }

  switch (fillColor) {
    case Color.Transparent:
      baseIconName += '_line';
      break;
    default:
      baseIconName += '_paint';
      break;
  }

  let lineIconName = 'dynamic/textbox/icon_txtbox_balloon_type';
  switch (type) {
    case ShapeKind.Sticky:
      lineIconName += '_01_line';
      break;
    case ShapeKind.Balloon:
      lineIconName += '_02_line';
      break;
  }

  const baseImageColorFilter = getColorFilter(fillColor);
  const lineImageColorFilter = getColorFilter(lineColor);

  const baseImgSrc = `${baseDir}/images/tool-icons/${baseIconName}.png`;
  const lineImgSrc = `${baseDir}/images/tool-icons/${lineIconName}.png`;

  return <>
    <IconImage
      src={lineImgSrc}
      svgStyle={{ ...iconPositonStyle, ...svgStyle }}
      { ...lineImageColorFilter } />
    <IconImage
      src={baseImgSrc}
      svgStyle={{ ...iconPositonStyle, ...svgStyle }} />
    <IconImage
      src={baseImgSrc}
      svgStyle={{ ...iconPositonStyle, ...svgStyle }}
      { ...baseImageColorFilter } />
    <IconImage
      src={textImgSrc}
      svgStyle={{ ...iconPositonStyle, ...svgStyle }}
      { ...textImageColorFilter } />
  </>;
});

const mapStateToProps = (appStates: AppStates) => {
  return { textbox: appStates.ui.textbox };
};

export default connect(mapStateToProps)(TextboxIconImage);
